import { ApiEndpoints } from "@shared/api/api-endpoints";
import { paymentApiClient } from "@shared/api/clients/apiClientFactory";
import { transformJsonToObject } from "@shared/utils/jsonToObjectTransformer";

const getPSPConfigurationDetails = async (remoteUtilityId: string): Promise<any> => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "payment",
    "psp",
    (query) => {
      query.push("remote_utility_id", remoteUtilityId);
    }
  );
  const response = await paymentApiClient.get(url);
  return transformJsonToObject<any>(response.data.result);
};

const getChoices = async (choice: string): Promise<any> => {
  const url = ApiEndpoints.createUrlWithPathVariables("payment", "choices", [
    choice,
  ]);
  const response = await paymentApiClient.get(url);
  // Transform response.data.result from { key, value } to { label: key, value }
  const transformed = response.data.result.map(
    (item: { key: any; value: any }) => ({
      label: item.value,
      value: item.key,
    })
  );
  return transformed;
};

const updatePSPConfigurationDetails = async (
  pspId: number,
  payload: any
): Promise<any> => {
  const url = ApiEndpoints.createUrlWithPathVariables(
    "payment",
    "psp-utility-mapping",
    [pspId]
  );
  const response = await paymentApiClient.put(url, payload);
  return transformJsonToObject<any>(response.data.result);
};

const addPaymentConfig = async (payload: any) => {
  const url = ApiEndpoints.createUrl("payment", "psp-utility-mapping");
  const response = await paymentApiClient.post(url, payload);
  return response.data ?? null;
};

const connectPaymentMethod = async (payload: any) => {
  const url = ApiEndpoints.createUrl("payment", "initiate-payment");
  const response = await paymentApiClient.post(url, payload);
  return response.data.result ?? null;
};

const decryptPSPCredentials = async (pspId: number): Promise<any> => {
  const url = ApiEndpoints.createUrlWithPathVariables(
    "payment",
    "psp-decrypt-credentials",
    [pspId]
  );
  const response = await paymentApiClient.get(url);
  return transformJsonToObject<any>(response.data.result);
};

export const ixIntegrationApi = {
  getPSPConfigurationDetails,
  updatePSPConfigurationDetails,
  addPaymentConfig,
  connectPaymentMethod,
  decryptPSPCredentials,
  getChoices,
};
